<template>
  <div class="left">
    <box-container class="left-content" title="用户数">
      <studentCount />
    </box-container>
    <box-container class="left-content" title="课程人数">
      <course-student-count />
    </box-container>
    <box-container class="left-content" title="报名比例">
      <student-count-for-sign-course-count />
    </box-container>
  </div>
</template>

<script>
import boxContainer from './boxContainer'
import studentCount from './studentCount'
import courseStudentCount from './courseStudentCount'
import studentCountForSignCourseCount from './studentCountForSignCourseCount'

export default {
  name: 'Left',
  components: {
    boxContainer,
    studentCount,
    courseStudentCount,
    studentCountForSignCourseCount
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less">
.left {
    width: 32%;
    margin: 0.5%;

    .left-content {
        width: 100%;
        height: 33%;
        display: flex;
    }
}
</style>
